import { locationOf, targetLabel } from './findingTarget';

export const FINDINGS_PAGE_SIZE = 50;

const SEV_ORDER = ['critical', 'high', 'medium', 'low', 'info'];

export function findingMatchesFramework(f, fwName) {
  if (!fwName) return true;
  const needle = fwName.toLowerCase();
  if (Array.isArray(f.complianceMappings)) {
    for (const m of f.complianceMappings) {
      if (typeof m === 'string') {
        if (m.toLowerCase().includes(needle)) return true;
      } else if (m && typeof m === 'object') {
        if ((m.framework ?? '').toLowerCase().includes(needle)) return true;
      }
    }
  }
  if (typeof f.complianceJson === 'string' && f.complianceJson.toLowerCase().includes(needle)) return true;
  if (f.complianceJson && typeof f.complianceJson === 'object') {
    try {
      if (JSON.stringify(f.complianceJson).toLowerCase().includes(needle)) return true;
    } catch { /* ignore */ }
  }
  return false;
}

function findingMatchesSearch(f, query) {
  const search = query.trim().toLowerCase();
  if (!search) return true;
  return [
    f.title,
    f.asset,
    f.cve,
    f.cveId,
    f.evidenceConfidence,
    f.module,
    f.fingerprint,
    f.id,
    f.description,
    targetLabel(f),
    locationOf(f),
    f.detail?.affectedComponent,
    f.detail?.sourceDomain,
    f.detail?.sourceApp,
  ].filter(Boolean).join(' ').toLowerCase().includes(search);
}

export function filterAndSortFindings(findings, filters = {}) {
  let all = [...findings];

  if (filters.severity) {
    const target = (filters.severity || '').toLowerCase();
    all = all.filter(f => f.sev === target);
  }
  if (filters.status) {
    const target = (filters.status || '').toLowerCase();
    all = all.filter(f => f.status === target);
  }
  if (filters.module) {
    const target = (filters.module || '').toLowerCase();
    all = all.filter(f => (f.module || '').toLowerCase().includes(target));
  }
  if (filters.latestScanJobId) {
    all = all.filter(f => f.lastDetectedScanJobId === filters.latestScanJobId);
  }
  if (filters.framework) {
    all = all.filter(f => findingMatchesFramework(f, filters.framework));
  }
  if (filters.minEpss != null) {
    all = all.filter(f => (f.ep ?? 0) >= filters.minEpss);
  }
  if (filters.search) {
    all = all.filter(f => findingMatchesSearch(f, filters.search));
  }

  if (filters.sort === 'sev') {
    all.sort((a, b) => SEV_ORDER.indexOf(a.sev) - SEV_ORDER.indexOf(b.sev));
  } else if (filters.sort === 'epss') {
    all.sort((a, b) => (b.ep ?? 0) - (a.ep ?? 0));
  } else {
    all.sort((a, b) => new Date(b.age ?? 0) - new Date(a.age ?? 0));
  }

  return all;
}

export function filterSortAndPageFindings(findings, filters = {}) {
  const filtered = filterAndSortFindings(findings, filters);
  const page = Math.max(filters.page ?? 1, 1);
  const pageSize = filters.pageSize ?? FINDINGS_PAGE_SIZE;
  const start = (page - 1) * pageSize;

  return {
    data: filtered.slice(start, start + pageSize),
    total: filtered.length,
    open: filtered.filter(f => f.status === 'open').length,
  };
}
